import { BRAND } from "constants/brand";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

import { Form } from "react-bootstrap";

import { CSSTransition } from "react-transition-group";
import { Ring } from "@uiball/loaders";
import Select from "components/Ui/SelectField/SelectField";
import useGroups from "hooks/useGroups";

const CopyGroups = (props) => {
    const form = useRef();
    const nodeRef = useRef();

    const [vendor, setVendor] = useState();

    const { loading, fetchOptions, options, copyGroups } = useGroups();

    useEffect(() => {
        fetchOptions();
    }, []);

    const submitHandler = async (e) => {
        e.preventDefault();
        try {
            const response = await copyGroups({
                products: props.selectedProducts,
                id: vendor,
            });
            // Assuming `response` contains information to check if the operation succeeded

            props.showMessage("success", "تمت الاضافه", "تمت إضافه المناطق بنجاح");
            props.close(); // Uncomment if you need to close a modal or similar
        } catch (err) {
            console.error("Error adding vendor:", err);
            props.showMessage("error", "هناك خطأ", err || "حدث خطأ غير متوقع");
        }
    };

    return (
        <>
            <div className={`model ${props.show ? "model-show" : ""}`} onClick={props.close}>
                <CSSTransition
                    mountOnEnter
                    unmountOnExit
                    nodeRef={nodeRef}
                    in={props.show}
                    timeout={400}
                    classNames="show"
                >
                    <div
                        className="addItem"
                        style={{ overflow: "visible" }}
                        ref={nodeRef}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {loading ? (
                            <div className="loading-spinner center">
                                <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                            </div>
                        ) : null}
                        <div
                            className="head center"
                            style={{
                                borderTopLeftRadius: "10px",
                                borderTopRightRadius: "10px",
                            }}
                        >
                            <h5>نسخه الاضافه إالي المنتجات</h5>
                            <FontAwesomeIcon icon={faClose} onClick={props.close} />
                        </div>
                        <Form className="form" ref={form} onSubmit={submitHandler}>
                            <Form.Group className="mb-3" controlId="status">
                                <Form.Label>
                                    الاضافه<span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Select
                                    options={options.map((o) => ({ value: o.id, label: o.name }))}
                                    placeholder={"الاضافات"}
                                    onChange={(selected) => {
                                        if (!selected || selected.value === "") {
                                            setVendor(null);
                                        } else {
                                            setVendor(selected.value);
                                        }
                                    }}
                                />
                            </Form.Group>

                            <div className="buttons">
                                <button className="cancel" onClick={props.close} type="button">
                                    إلغاء
                                </button>
                                <button className="button" type="submit">
                                    نسخ الاضافات
                                </button>
                            </div>
                        </Form>
                    </div>
                </CSSTransition>
            </div>
        </>
    );
};
export default CopyGroups;
